/* FUNCTIONS ---------------------------------------------------------------------------------------------------- */
//= ./_functions/_native/supportWebpAvif.js
//= ./_functions/_native/getAppHeight.js
//= ./_functions/_native/getScrollWidth.js
//= ./_functions/_native/headerScrollChange.js
/* MAIN --------------------------------------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
    supportWebpAvif();
    getAppHeight();
    getScrollWidth();
    headerScrollChange(0);

    /* lottie animations */
    $('.js-lottie-animations').each(function (index, item){
        var animation = bodymovin.loadAnimation({
            container: document.getElementById($(item).attr('id')),
            renderer: 'svg',
            loop: $(item).hasClass('js-lottie-loop'),
            autoplay: $(item).hasClass('js-lottie-loop'),
            path: $(item).attr('data-json'),
            name: $(item).attr('id')
        });
    });
    $('.js-lottie-wrapper').each(function (index, item){
        $(item).hover(function (){
            if(!$(item).find('.js-lottie-animations').hasClass('show')){
                $(item).find('.js-lottie-animations').addClass('show');
                bodymovin.play($(item).find('.js-lottie-animations').attr('id'));
                setTimeout(function (){
                    bodymovin.stop($(item).find('.js-lottie-animations').attr('id'));
                    $(item).find('.js-lottie-animations').removeClass('show');
                },2000);
            }
        }, function (){
        });
    });

    /* wow animation */
    new WOW({
        offset: 0,
        callback: function (e){
            if($(e).hasClass('js-lottie-animations')){
                bodymovin.play($(e).attr('id'));
                if(!$(e).hasClass('js-lottie-loop')){
                    setTimeout(function (){
                        bodymovin.stop($(e).attr('id'));
                    },2000);
                }
            }
        }
    }).init();

    /* header */
    // submenu
    if ($(window).width() > 1199) {
        $('.header .js-subitem-link').hover(
            function() {
                $(this).addClass('active');
                $(this).find('.submenu-wrapper').stop().slideDown(300);
            },
            function() {
                $(this).removeClass('active');
                $(this).find('.submenu-wrapper').stop().slideUp(300);
            }
        );
    };
    // main menu function
    $(".hamburger").click(function () {
        $(this).toggleClass('is-active');
        $('#' + $(this).attr('data-menu')).toggleClass('show');
        $('body').toggleClass('overflow menu-show');
    });
    $(document).click(function (e) {
        var container = $(".header");
        if (container.has(e.target).length === 0 && e.target.className != 'hamburger hamburger--slider is-active'){
            if ($('.hamburger').hasClass("is-active")) {
                $('.hamburger').removeClass('is-active');
                $('#main-menu').removeClass("show");
                $('body').removeClass('overflow menu-show');
            }
        }
    });
    // scroll link
    $(document).on('click', '.js-scroll-link', function (){
        var curSection = $('#' + $(this).attr('data-id')),
            headerHeight = $('.header').height();
        console.log(headerHeight);
        if(curSection.length > 0){
            $('html, body').animate({
                scrollTop: curSection.offset().top - headerHeight
            }, 1000);
        }
    });
    // projects slider
    $('.js-projects-slider').each(function (index, slider) {
        var projectsSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 0,
            navigation: {
                nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
            }
        });
    });
    // answers slider
    $('.js-answers-slider').each(function (index, slider) {
        var answersSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            centeredSlides: true,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 24,
            navigation: {
                nextEl: $(slider).parents('.answers-section').find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).parents('.answers-section').find('.slider-navigation .nav-btn.prev-btn')[0],
            },
            breakpoints: {
                960: {
                    slidesPerView: 2
                }
            }
        });
    });
    // plan slider
    $('.js-plan-slider').each(function (index, slider) {
        var planSlider = new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 0,
            navigation: {
                nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
            }
        });
    });
    // custom select
    $(document).on('click', '.js-custom-select .js-current-value', function() {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().toggleClass('active');
            $(this).toggleClass('active');
            $(this).parent().find('.list-wrapper').slideToggle(300);
        } else {
            $('.js-custom-select.active .js-current-value').removeClass('active');
            $('.js-custom-select.active .list-wrapper').slideUp(0);
            $('.js-custom-select.active').removeClass('active');
            $(this).parent().toggleClass('active');
            $(this).toggleClass('active');
            $(this).parent().find('.list-wrapper').slideToggle(300);
        }
    });
    // close custom select
    $(document).on('click', function(e) {
        if (!e.target.classList.contains('js-current-value') && !e.target.classList.contains('checkbox-label') && !e.target.classList.contains('checkbox-input')) {
            $('.js-custom-select.active .js-current-value').removeClass('active');
            $('.js-custom-select.active .list-wrapper').slideUp(0);
            $('.js-custom-select.active').removeClass('active');
        };
    });
    // filter form check show
    $('.js-filter-form').each(function (index, form){
        // prepare on load
        $(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').remove();
        $(this).find('input[type="checkbox"]:checked').each(function (index, el){
            $(this).parents('.js-form-wrapper').find('.js-check-list').prepend('<a href="javascript:void(0);" class="check-item js-check-item" data-value="'+ $(this).attr('value') +'">'+ $(this).siblings('span').text() +'</a>');
        });
        if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 0){
            $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeIn(300);
        };
        if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 4){
            $(form).parents('.js-form-wrapper').find('.js-show-list').fadeIn(300);
        };
        // change
        $(form).on('change', function (){
            $(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').remove();
            $(this).find('input[type="checkbox"]:checked').each(function (index, el){
                $(this).parents('.js-form-wrapper').find('.js-check-list').prepend('<a href="javascript:void(0);" class="check-item js-check-item" data-value="'+ $(this).attr('value') +'">'+ $(this).siblings('span').text() +'</a>');
            });
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 0){
                $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeIn(300);
            };
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length > 4){
                $(form).parents('.js-form-wrapper').find('.js-show-list').fadeIn(300);
            };
        });
        $(form).parents('.js-form-wrapper').on('click', '.js-check-item', function (){
            $(form).find('input[type="checkbox"][value="'+ $(this).attr('data-value') +'"]').prop('checked', false);
            $(this).remove();
            mSearch2.submit();
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length < 1){
                $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeOut(300);
            };
            if($(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').length < 5){
                $(form).parents('.js-form-wrapper').find('.js-show-list').fadeOut(300);
            };
        });
        $(form).parents('.js-form-wrapper').on('click', '.js-show-list', function (){
                $(this).toggleClass('active');
                $(form).parents('.js-form-wrapper').find('.js-check-list').toggleClass('show');
        });
        $(form).parents('.js-form-wrapper').on('click', '.js-clean-list', function (){
            $(form).find('input[type="checkbox"]').prop('checked', false);
            $(form).parents('.js-form-wrapper').find('.js-check-list .js-check-item').remove();
            $(form).parents('.js-form-wrapper').find('.js-show-list').fadeOut(0).removeClass('active');
            $(form).parents('.js-form-wrapper').find('.js-show-list').fadeOut(0).removeClass('active');
            $(form).parents('.js-form-wrapper').find('.js-clean-list').fadeOut(0);
            $(form).parents('.js-form-wrapper').find('.js-check-list').removeClass('show');
            mSearch2.reset();
        });
    });
    // videos filter fix
    $('.videos-main__tags').on('change', function (){
        $('.videos-main__tags .js-filter-reset').removeClass('active');
    });
    $(document).on('click', '.js-filter-reset', function (){
        mSearch2.reset();
        $(this).addClass('active');
    });
    // houses slider
    $('.js-houses-slider').each(function(index, slider) {
        var housesSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 10,
            navigation: {
                nextEl: $(slider).parents('.houses-section').find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).parents('.houses-section').find('.slider-navigation .nav-btn.prev-btn')[0],
            },
            breakpoints: {
                1441: {
                    spaceBetween: 45
                },
                1337: {
                    spaceBetween: 20
                },
                1201: {
                    spaceBetween: 45
                },
                1025: {
                    spaceBetween: 40
                },
                769: {
                    spaceBetween: 30
                },
                576: {
                    spaceBetween: 15
                }
            }
        });
    });
    // equipment slider
    $('.equipment-section').each(function (index, section){
        var init = false;
        var equipSlider = Swiper;
        function equipInit(){
            if($(window).width() < 576){
                if(!init){
                    init = true;
                    $(section).find('.js-equipment-slider').each(function(index, slider) {
                        equipSlider = new Swiper(slider, {
                            slidesPerView: 'auto',
                            watchSlidesProgress: true,
                            speed: 800,
                            spaceBetween: 10,
                        });
                    });
                }
            }
            else{
                if(init){
                    equipSlider.destroy();
                    init = false;
                }
            }
        }
        equipInit();
        $(window).on('resize', function (){
            equipInit();
        });
    });
    // see slider
    $('.js-see-slider').each(function(index, slider) {
        var housesSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 10,
            navigation: {
                nextEl: $(slider).parents('.see-section').find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).parents('.see-section').find('.slider-navigation .nav-btn.prev-btn')[0],
            },
            breakpoints: {
                1441: {
                    spaceBetween: 45
                },
                1337: {
                    spaceBetween: 20
                },
                1201: {
                    spaceBetween: 45
                },
                1025: {
                    spaceBetween: 40
                },
                769: {
                    spaceBetween: 30
                },
                576: {
                    spaceBetween: 15
                }
            }
        });
    });
    // news slider
    $('.js-news-slider').each(function(index, slider) {
        var newsSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            speed: 800,
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: $(slider).parents('.news-section').find('.slider-navigation .nav-btn.next-btn')[0],
                prevEl: $(slider).parents('.news-section').find('.slider-navigation .nav-btn.prev-btn')[0],
            }
        });
    });
    // scroll info section blocks change
    if($('.info-section').length > 0){
        window.addEventListener('scroll', function (){
            var scroll = this.scrollY,
                offset = 450,
                scrollOffset = 650;
            $('.info-section .info-section__content__item').each(function (index, el) {
                if(scroll > $(el).offset().top - offset){
                    $('.info-section .info-section__content__item').removeClass('active');
                    $(el).addClass('active');
                }
            });
        });
    };
    // questions show function
    if($('.questions-section').length > 0){
        $('.questions-section').on('click', '.js-question-title', function (){
           $(this).toggleClass('active');
           $(this).siblings('.item-descr').slideToggle(300);
        });
    };
    // card slider
    $('.card-main').each(function (index, section){
        var cardThumbs = new Swiper('#card-thumbs', {
            slidesPerView: 3,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 14
        });
        var cardMain = new Swiper('#card-main', {
            slidesPerView: 1,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 20,
            thumbs: {
                swiper: '#card-thumbs'
            },
            navigation: {
                nextEl: '.slider-navigation .nav-btn.next-btn',
                prevEl: '.slider-navigation .nav-btn.prev-btn',
            },
        });
    });
    // card equipment
    $('.card-equip').on('click', '.js-switch-btn', function (){
       $(this).parent().find('.js-switch-btn').removeClass('active');
       $(this).addClass('active');
       if($(this).attr('data-value') == 'all'){
           $(this).parent().find('input[type="checkbox"]').prop('checked', true);
           $(this).parents('.equip-table').removeClass('different-show');
       }
       else{
           $(this).parent().find('input[type="checkbox"]').prop('checked', false);
           $(this).parents('.equip-table').addClass('different-show');
       }
    });
    $('.card-equip').on('change', '.js-view-type', function (){
       $(this).parents('.switch-row').find('.js-switch-btn').removeClass('active');
       if($(this).prop('checked')){
           $(this).parents('.switch-row').find('.js-switch-btn[data-value="all"]').addClass('active');
           $(this).parents('.equip-table').removeClass('different-show');
       }
       else{
           $(this).parents('.switch-row').find('.js-switch-btn[data-value="different"]').addClass('active');
           $(this).parents('.equip-table').addClass('different-show');
       }
    });
    // card hide header
    if($('.card-equip').length > 0){
        var tableTop = $('.card-equip .equip-table').offset().top,
            tableBottom = $('.card-equip .equip-table').offset().top + $('.card-equip .equip-table').height();
        $(window).scroll(function(){
            var windowBottom = $(document).scrollTop() + window.innerHeight;
            if($(document).scrollTop() >= tableTop && $(document).scrollTop() < (tableBottom - 128)){
                $('.header').stop().fadeOut(300);
                $('.card-equip .equip-table').addClass('sticky-header');
            }
            else{
                $('.header').stop().fadeIn(300);
                $('.card-equip .equip-table').removeClass('sticky-header');
            }
            if(windowBottom > tableBottom){
                $('.card-equip .equip-table').addClass('sticky-footer');
            }
            else{
                $('.card-equip .equip-table').removeClass('sticky-footer');
            }
        });
    }
    // about cards hover
    $('.about-main .js-card-hover').hover(
        function (){
            if(!$(this).hasClass('active')){
                $('.about-page .js-card-hover').removeClass('active');
                $('.about-page .js-card-hover').find('.item-descr').stop().slideUp(300);
            }
            $(this).addClass('active');
            $(this).find('.item-descr').stop().slideDown(300);
        },
        function (){
            $(this).removeClass('active');
            $(this).find('.item-descr').stop().slideUp(300);
        }
    );
    // reviews slider
    $('.js-exp-slider').each(function(index, slider) {
        var expSlider = new Swiper(slider, {
            slidesPerView: 1,
            watchSlidesProgress: true,
            loop: true,
            autoplay: {
                delay: 5000
            },
            speed: 800,
            spaceBetween: 20
        });
    });
    // video slider
    $('.review-section').each(function (index, section){
        // video slider
        var simpleThumbs = new Swiper($(section).find('.js-review-thumbs')[0], {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            speed: 800,
            direction: "horizontal",
            spaceBetween: 6,
            mousewheel: true,
            scrollbar: {
                el: ".swiper-scrollbar"
            },
            breakpoints: {
                1024: {
                    slidesPerView: 5,
                    direction: "vertical",
                },
                960: {
                    slidesPerView: 4,
                    direction: "vertical",
                }
            }
        });
        var simpleMain = new Swiper($(section).find('.js-review-main')[0], {
            slidesPerView: 1,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 20,
            thumbs: {
                swiper: $(section).find('.js-review-thumbs')[0]
            }
        });
    });
    // start show function
    $('.start-section').on('click', '.js-start-title', function (){
        if(!$(this).parent().hasClass('active')){
            $(this).parents('.start-section__content').find('.start-section__content__item.active').removeClass('active').find('.item-descr').slideUp(300);
            $(this).parent().addClass('active').find('.item-descr').slideDown(300);
        }
    });
    // team section
    $('.js-team-slider').each(function(index, slider) {
        var teamSlider = new Swiper(slider, {
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            speed: 800,
            loop: true,
            spaceBetween: 16,
            navigation: {
                nextEl: $('.js-team-slider').find('.slider-navigation-mobile .nav-btn.next-btn')[0],
                prevEl: $('.js-team-slider').find('.slider-navigation-mobile .nav-btn.prev-btn')[0],
            },

            breakpoints: {
                576: {
                    navigation: {
                        nextEl: $(slider).parents('.team-section').find('.slider-navigation .nav-btn.next-btn')[0],
                        prevEl: $(slider).parents('.team-section').find('.slider-navigation .nav-btn.prev-btn')[0],
                    },
                }
            }
        });
    });
    // contacts slider
    if($('.contacts-main').length > 0){
        var contactsSlider = new Swiper('#contacts-slider', {
            slidesPerView: 1,
            loop: true,
            centeredSlides: true,
            watchSlidesProgress: true,
            speed: 800,
            spaceBetween: 0,
            navigation: {
                nextEl: '.slider-navigation .nav-btn.next-btn',
                prevEl: '.slider-navigation .nav-btn.prev-btn',
            }
        });
    };

    /* inputs */
    // phone mask
    $.fn.setCursorPosition = function(pos) {
        if ($(this).get(0).setSelectionRange) {
            $(this).get(0).setSelectionRange(pos, pos);
        } else if ($(this).get(0).createTextRange) {
            var range = $(this).get(0).createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    };
    $('.js-phone-input').click(function (){
        $(this).setCursorPosition(3);
    }).mask("+7 (999) 999-99-99");

    /* modals */
    // simple modal
    $('.js-modal-link').magnificPopup({
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        showCloseBtn: false,
        tClose: 'Закрыть',
        mainClass: 'my-mfp-zoom-in',
        image: {
            tError: 'Невозможно загрузить :('
        },
        ajax: {
            tError: 'Невозможно загрузить :('
        },
        callbacks: {
            open: function(e) {
                $('body').addClass('overflow');
                var magnificPopup = $.magnificPopup.instance,
                    cur = magnificPopup.st.el;
                if(cur.attr('data-type') && cur.attr('href') == '#choose_modal'){
                    $('#choose_modal .modal-title').text(cur.attr('data-type'));
                    $('#choose_modal input[name="type"]').val(cur.attr('data-type'));
                }
            },
            close: function() {
                $('body').removeClass('overflow');
            }
        }
    });
    // close modal
    $('.js-modal-close').on('click', function (){
        $.magnificPopup.close();
    });
    // video modal
    $('.js-video-link').magnificPopup({
        type: 'iframe',
        mainClass: 'my-mfp-zoom-in',
        fixedContentPos: true,
        removalDelay: 160,
        preloader: false,
        tClose: 'Закрыть',
        callbacks: {
            open: function() {
                $('body').addClass('overflow');
            },
            close: function() {
                $('body').removeClass('overflow');
            }
        }
    });
    // video gallery
    $('.js-video-gallery').magnificPopup({
        delegate: '.item-link',
        type: 'iframe',
        mainClass: 'my-mfp-zoom-in mfp-gallery',
        fixedContentPos: true,
        removalDelay: 160,
        tClose: 'Закрыть',
        gallery: {
            enabled: true,
            tPrev: 'Назад',
            tNext: 'Вперед',
            tCounter: '<span class="mfp-counter"><span class="active">%curr%</span> / <span>%total%</span></span>'
        },
        callbacks: {
            open: () => {
                $('body').addClass('overflow');
                if ($(window).width() <= 1024) {
                    /* swipe detection */
                    $(window).on('touchstart', function(event) {
                        touchstartX = event.changedTouches[0].screenX;
                    });
                    $(window).on('touchend', function(event) {
                        touchendX = event.changedTouches[0].screenX;
                        handleGesure();
                    });

                    function handleGesure() {
                        if (touchendX < touchstartX && touchstartX - touchendX > 50) {
                            $.magnificPopup.instance.next();
                        }
                        if (touchendX > touchstartX && touchendX - touchstartX > 50) {
                            $.magnificPopup.instance.prev();
                        }
                    }
                }
            },
            close: function() {
                $('body').removeClass('overflow');
            }
        }
    });
    // gallery modal
    $('.js-gallery-block').magnificPopup({
        delegate: '.gallery-link',
        type: 'image',
        mainClass: 'my-mfp-zoom-in mfp-gallery',
        fixedContentPos: true,
        removalDelay: 160,
        tClose: 'Закрыть',
        gallery: {
            enabled: true,
            tPrev: 'Назад',
            tNext: 'Вперед',
            tCounter: '<span class="mfp-counter"><span class="active">%curr%</span> / <span>%total%</span></span>'
        },
        callbacks: {
            open: () => {
                $('body').addClass('overflow');
                if ($(window).width() <= 1024) {
                    /* swipe detection */
                    $(window).on('touchstart', function(event) {
                        touchstartX = event.changedTouches[0].screenX;
                    });
                    $(window).on('touchend', function(event) {
                        touchendX = event.changedTouches[0].screenX;
                        handleGesure();
                    });

                    function handleGesure() {
                        if (touchendX < touchstartX && touchstartX - touchendX > 50) {
                            $.magnificPopup.instance.next();
                        }
                        if (touchendX > touchstartX && touchendX - touchstartX > 50) {
                            $.magnificPopup.instance.prev();
                        }
                    }
                }
            },
            close: function() {
                $('body').removeClass('overflow');
            }
        }
    });
    $('.js-gallery-slider').magnificPopup({
        delegate: '.gallery-link',
        type: 'image',
        mainClass: 'my-mfp-zoom-in mfp-gallery',
        fixedContentPos: true,
        removalDelay: 160,
        tClose: 'Закрыть',
        gallery: {
            enabled: true,
            tPrev: 'Назад',
            tNext: 'Вперед',
            tCounter: '<span class="mfp-counter"><span class="active">%curr%</span> / <span>%total%</span></span>'
        },
        callbacks: {
            open: () => {
                $('body').addClass('overflow');
                if ($(window).width() <= 1024) {
                    /* swipe detection */
                    $(window).on('touchstart', function(event) {
                        touchstartX = event.changedTouches[0].screenX;
                    });
                    $(window).on('touchend', function(event) {
                        touchendX = event.changedTouches[0].screenX;
                        handleGesure();
                    });

                    function handleGesure() {
                        if (touchendX < touchstartX && touchstartX - touchendX > 50) {
                            $.magnificPopup.instance.next();
                        }
                        if (touchendX > touchstartX && touchendX - touchstartX > 50) {
                            $.magnificPopup.instance.prev();
                        }
                    }
                }
            },
            close: function() {
                $('body').removeClass('overflow');
            }
        }
    });
    $('.js-gallery-product').magnificPopup({
        delegate: '.gallery-link',
        type: 'image',
        mainClass: 'my-mfp-zoom-in mfp-gallery',
        fixedContentPos: true,
        removalDelay: 160,
        tClose: 'Закрыть',
        gallery: {
            enabled: true,
            tPrev: 'Назад',
            tNext: 'Вперед',
            tCounter: '<span class="mfp-counter"><span class="active">%curr%</span> / <span>%total%</span></span>'
        },
        callbacks: {
            open: () => {
                $('body').addClass('overflow');
                if ($(window).width() <= 1024) {
                    /* swipe detection */
                    $(window).on('touchstart', function(event) {
                        touchstartX = event.changedTouches[0].screenX;
                    });
                    $(window).on('touchend', function(event) {
                        touchendX = event.changedTouches[0].screenX;
                        handleGesure();
                    });

                    function handleGesure() {
                        if (touchendX < touchstartX && touchstartX - touchendX > 50) {
                            $.magnificPopup.instance.next();
                        }
                        if (touchendX > touchstartX && touchendX - touchstartX > 50) {
                            $.magnificPopup.instance.prev();
                        }
                    }
                }
            },
            close: function() {
                $('body').removeClass('overflow');
            }
        }
    });

    /* filter reload fix */
    $(document).on('mse2_load', function(e, data) {
        // video modal
        $('.js-video-link').magnificPopup({
            type: 'iframe',
            mainClass: 'my-mfp-zoom-in',
            fixedContentPos: true,
            removalDelay: 160,
            preloader: false,
            tClose: 'Закрыть',
            callbacks: {
                open: function() {
                    $('body').addClass('overflow');
                },
                close: function() {
                    $('body').removeClass('overflow');
                }
            }
        });
    });

    // stocks
    if(Cookies.get('stocksCookie') != 'hidden'){
        setTimeout(function (){
            $('#bottomNotice').fadeIn(300);
        }, 1000)
    };
    $('.js-notice-close').on('click',function(){
        Cookies.set('stocksCookie', 'hidden', { expires: 1 });
        $('#bottomNotice').fadeOut(300);
    });


    /* modx ajax form fix */
    AjaxForm.Message.error = function(){};
    AjaxForm.Message.success = function(){};

    $(document).on('af_complete', function(event,res) {
        if(res.success){
            window.location.href = "/spasibo.html"
        };
    });

    /* do not remove :) */
    //= ./_functions/_native/progInfo.js
});